// make random so table values never match
export const LOADING_IDENTIFIER = '][12#*%&!@*#';

export const HTML_TITLE_SUFFIX = " | Citizenry Dash";
